/** Published Finturf legal documents linked from co-application disclosures. */
export const FINTURF_PRIVACY_POLICY_URL =
    'https://docs.google.com/document/d/e/2PACX-1vRT0wOaRqscMHpRDW0ouF_JT_dGv43Y6Jvm-uutn_Ot6sOFlY9KvSyC0lfa9t_ex6PodGnnUR62dXzH/pub';

export const FINTURF_TERMS_URL =
    'https://docs.google.com/document/d/e/2PACX-1vRGdTncrse8i8f0mVSaQAMFpzSrSuQZ82aV-eF2bZ1ksEA2XJUvw5NxY1BDvpQjz3gcqfGYhbgtHBRh/pub';

export const FINTURF_E_CONSENT_URL =
    'https://docs.google.com/document/d/e/2PACX-1vRG9TXCNpGf8sfbBnVfHsPq2q40p_ofqyWdZEGifedk3jALRVOBlpMe2E_MWZ2HQmBNBU9QBn0mFUhj/pub';

export const FINTURF_IMPORTANT_DISCLOSURES_URL =
    'https://docs.google.com/document/d/e/2PACX-1vRodGtFrghA5bjx49XaZOipDbSGg9FV8miO4JmSn4oPrwfQkdUz2Th9Vk3Se4IUe7q2ZA_cRQkAaxB1/pub';

export const FINTURF_TCPA_PARTNERS_URL =
    'https://docs.google.com/document/d/e/2PACX-1vRLXnS_-xcsGV3zSOCMKQpS5-eUbSBbij6FgMRZaIK7s2RaLRBnkPWLBWUjOgAaGeZuOZyMX0NtOFx2/pub';
